import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import {
  PrintPolicy,
  PrintPolicyPrinter,
  PrintPolicyItem,
  PrintPolicyItemCategory,
  PrintPolicyIgnoredItem,
  PrintPolicySaleMethodBranch,
  PrintPolicySalon,
  PrintPolicyDependency,
  PrintPolicyPrintTimeEnum,
} from "../model/print-policy.model";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { take, takeUntil } from "rxjs/operators";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Item } from "../../catalog/model/item.model";
import { AccountService, LocalStoreManager, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Lookup, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { SoftWareLicenseKind } from "../../../../../projects/sepidz-web-framework/src/lib/models/license-information.model";
import { DialogType } from "../../../../../projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { SplashScreenService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/SplashScreenService";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";

@Component({
  selector: "ngx-print-policy-form",
  templateUrl: "./print-policy-form.component.html",
  styleUrls: ["./print-policy-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintPolicyFormComponent extends BaseFormComponent<PrintPolicy> {
  haserror: boolean = false;
  erroremessage: string;
  Categories: number[] = [];
  Items: number[] = [];
  IgnoredItems: number[] = [];
  ItemWithCategory: Item[] = [];
  IgnoredItemsWithCategory: Item[] = [];
  Printers: any;
  SaleMethodBranches: number[] = [];
  Salons: number[] = [];
  Dependents: number[] = [];
  PrintPolicyDependencies: PrintPolicy[] = [];
  PrintPolicies: PrintPolicy[] = [];
  customerPrint: boolean = false;
  printTime: Lookup[] = [];
  isLodes: boolean = false;
  IsokForRefresh: boolean = true;
  PrinterList: any[] = [];
  islightVersion: boolean = false;
  islightVersionLimitation: boolean = false;
  PrinterPolicyList: PrintPolicy[];
  constructor(
    private lookupService: LookupService,
    private accountservice: AccountService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    public splashScreenService: SplashScreenService,
    public splashFormService: SplashFormService,
    private storage: LocalStoreManager
  ) {
    super(selectorService, cd);
    this.PreData();
  }

  PreData() {
    if (this.accountservice.authService.currentInformation().SepidzWebKind === SoftWareLicenseKind.RestaurantLightWeb) {
      this.islightVersion = true;
      this.httpCommonService
        .getList("PrintPolicy")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: PrintPolicy[]) => {
            if (data) {
              this.PrinterPolicyList = data;
              if (this.currentrow?.Id && data?.length == 1) {
                this.islightVersionLimitation = false;
              } else {
                if (data?.length >= 1) {
                  this.islightVersionLimitation = true;
                  if (this.currentrow?.Id) {
                    this.sts.showDialog(
                      this.translate("ClientApp.FrontOffice.PrintPolicy.LiteVersionNotAllowAccessAboveOne"),
                      this.translate("ClientApp.FrontOffice.PrintPolicy.ErrorMessage"),
                      DialogType.alert,
                      () => {
                        this.close();
                      }
                    );
                    return;
                  }
                } else {
                  this.islightVersionLimitation = false;
                }
              }
            }
            this.FillFirstData();
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.FillFirstData();
    }
  }

  async ngOnInit() {
    this.apiName = "PrintPolicy";
    this.label = this.translate("ClientApp.FrontOffice.PrintPolicy.PrintConfiguration");
    super.ngOnInit();
  }

  FillFirstData() {
    if (this.model && !this.model.PrintTimeId) {
      this.lookupService
        .getLookupbyCategory("GNR", "PrintTime")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (x) => {
          this.printTime = x;
          const findItem = x.find((f) => f.Code == PrintPolicyPrintTimeEnum.PreparationPrint);
          this.model.PrintTimeId = findItem.Id;

          this.model.PrintTimeTitle = findItem.Title;
          this.model.PrintTimeCode = findItem.Code;
          this.setValue("PrintTimeId", findItem.Id);
          this.setValue("PrintTimeTitle", findItem.Title);
          this.setValue("PrintTimeCode", findItem.Code);
        });
    }
    if (!this.accountService?.authService?.currentBranch?.HasLocalService) {
      this.httpCommonService
        .getList("PrintPolicy/ReadPrintersLookUp")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: PrintPolicy[]) => {
            if (data) {
              this.PrinterList = data;
              if (this.islightVersionLimitation && this.PrinterPolicyList?.length > 0) {
                this.PrinterList = this.PrinterList.filter((f) => f.Title == this.PrinterPolicyList[0].Printers[0].Name);
              }
            }
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      const url = "http://" + this.accountService.authService.currentBranch.LocalServiceIp + "/GetPrinters";
      this.httpCommonService
        .getCustom(url)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: any) => {
            if (data) {
              this.PrinterList = data;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  setdefault() {
    if (this.model?.Id && this.model?.LocalServiceIp) {
      const url = "http://" + this.model.LocalServiceIp + "/GetPrinters";
      this.httpCommonService
        .getCustom(url)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: any) => {
            if (data) {
              this.PrinterList = data;
            }
          },
          (err) => {
            console.log(err);
          }
        );
    }
    if (this.model) this.ReadPrintPolicies(this.model.Id ? this.model.Id : null);
    if (!this.model.IgnoredItems) this.model.IgnoredItems = [];
    if (!this.model.Items) this.model.Items = [];
    if (!this.model.Categories) this.model.Categories = [];
    if (!this.model.Printers) this.model.Printers = [];
    if (!this.model.SaleMethodBranches) this.model.SaleMethodBranches = [];
    if (!this.model.Salons) this.model.Salons = [];
    if (!this.model.Dependents) this.model.Dependents = [];
    if (!this.Printers) {
      this.Printers = [];
    }

    this.model?.Categories?.forEach((x) => {
      if (!this.Categories.some((d) => d === x.ItemCategoryId)) this.Categories.push(x.ItemCategoryId);
    });
    this.model?.IgnoredItems?.forEach((x) => {
      if (!this.IgnoredItems.some((d) => d === x.ItemId)) this.IgnoredItems.push(x.ItemId);
    });
    this.model?.Items?.forEach((x) => {
      if (!this.Items.some((d) => d === x.ItemId)) this.Items.push(x.ItemId);
    });
    if (this.islightVersion) {
      this.Printers = this.model.Printers[0].Name;
    } else {
      this.model?.Printers?.forEach((x) => {
        this.Printers.push(x.Name);
      });
    }

    this.model?.SaleMethodBranches?.forEach((x) => {
      if (!this.SaleMethodBranches.some((d) => d === x.SaleMethodBranchId)) this.SaleMethodBranches.push(x.SaleMethodBranchId);
    });
    this.model?.Salons?.forEach((x) => {
      if (!this.Salons.some((d) => d === x.SalonId)) this.Salons.push(x.SalonId);
    });
    this.model?.Dependents?.forEach((x) => {
      if (!this.Dependents.some((d) => d === x.DependentPrintPolicyId)) this.Dependents.push(x.DependentPrintPolicyId);
    });

    this.valueChange();
    if (this.model.PrintTimeId) {
      this.onPrintTimeIdChanges(this.model.PrintTimeId);
    }
    this.setComputerName();
  }

  addControl() {
    if (this.formGroup) {
      this.setValue("IgnoredItems", this.IgnoredItems);
      this.setValue("Items", this.Items);
      this.setValue("Categories", this.Categories);
      this.setValue("Printers", this.Printers);
      this.setValue("PrintTemplateId", this.model.PrintTemplateId);
      this.setValue("SaleMethodBranches", this.SaleMethodBranches);
      this.setValue("Salons", this.Salons);
      this.setValue("Dependents", this.Dependents);
      this.setValue("HasLocalSetting", this.model.HasLocalSetting);
    }
    if (this.model.PrintTimeCode === PrintPolicyPrintTimeEnum.CustomerPrint) {
      this.orignalColumns.forEach((x) => {
        if (x.name === "IsOrderPrint") x.formVisible = false;
        if (x.name === "IsReceiptPrint") x.formVisible = true;
      });
    }
    if (this.currentrow) {
      this.orignalColumns.forEach((x) => {
        if (x.name === "PrintPolicyStencil") x.formVisible = false;
      });
    }
    this.orignalColumns.forEach((x) => {
      if (x.name === "PrintPolicyStencil") {
        if (!x.formVisible) {
          this.orignalColumns.filter((c) => c.name === "Description")[0].userClass = "select-sm";
        }
      }
    });
    //     if (x.name == "PrintTimeId") x.isFloat = 0;
    //   });
    // }
    this.cd.markForCheck();
    this.formGroup
      ?.get("PrintTimeId")
      ?.valueChanges?.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        this.onPrintTimeIdChanges(x);
      });
    this.formGroup
      ?.get("HasLocalSetting")
      ?.valueChanges?.pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        this.showLocalSetting();
      });
  }

  valueChange() {
    if (this.formGroup) {
      this.Categories = this.formGroup.controls["Categories"]?.value;
      this.Items = this.formGroup.controls["Items"]?.value;
      this.IgnoredItems = this.formGroup.controls["IgnoredItems"]?.value;
    }

    this.httpCommonService
      .createlist("Item/GetItemWithCategory", this.Categories)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: Item[]) => {
        this.ItemWithCategory = x;
        this.selectorService.setDataList("Items", this.ItemWithCategory);
        var list: number[] = [];
        this.Items?.forEach((x) => {
          if (this.ItemWithCategory.some((i) => i.Id === x)) {
            list.push(x);
          }
        });
        this.Items = list;
        this.formGroup.controls["Items"].setValue(this.Items);
      });

    this.httpCommonService
      .createlist("Item/GetIgnoredItem", this.Categories)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((x: Item[]) => {
        this.IgnoredItemsWithCategory = x;
        this.selectorService.setDataList("IgnoredItems", this.IgnoredItemsWithCategory);
        let list: number[] = [];
        this.IgnoredItems?.forEach((x) => {
          if (this.IgnoredItemsWithCategory.some((i) => i.Id === x)) {
            list.push(x);
          }
        });
        this.IgnoredItems = list;
        this.formGroup.controls["IgnoredItems"].setValue(this.IgnoredItems);
      });
  }

  isValid(): boolean {
    this.erroremessage = undefined;
    this.haserror = false;
    if (this.formGroup?.controls["Printers"]?.value?.length <= 0) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.PrintPolicy.SelectingLeastOnePrinterRequired");
    } else if (!this.formGroup?.controls["PrintTemplateId"]?.value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.PrintPolicy.SelectingPrintTemplateRequired");
    } else if (!this.formGroup?.controls["PrintTimeId"]?.value) {
      this.haserror = true;
      this.erroremessage = this.translate("ClientApp.FrontOffice.PrintPolicy.SelectingPrintPolicyTypeRequired");
    }
    return !this.haserror;
  }

  beforupdate() {
    if (!this.formGroup.controls["LocalServiceIp"].value && this.formGroup.controls["HasLocalSetting"].value) {
      this.sts.showDialog(this.translate("ClientApp.FrontOffice.PrintPolicy.LocalServiceAddressMandatory"), "");
      return;
    }
    this.formGroup.controls.PrintPolicyStencil.setValue(null);
    this.Categories = this.formGroup.value.Categories;
    this.model?.Categories?.forEach((x) => {
      if (!this.Categories.some((r) => r === x.ItemCategoryId)) x.State = RowState.Delete;
    });
    this.Categories?.forEach((x) => {
      if (!this.model.Categories.some((r) => r.ItemCategoryId === x)) {
        var category: PrintPolicyItemCategory = <PrintPolicyItemCategory>{};
        category.ItemCategoryId = x;
        category.PrintPolicyId = this.model.Id;
        category.State = RowState.New;
        this.model.Categories.push(category);
      }
    });
    this.setValue("Categories", this.model?.Categories);

    this.IgnoredItems = this.formGroup.value.IgnoredItems;
    this.model?.IgnoredItems?.forEach((x) => {
      if (!this.IgnoredItems.some((r) => r === x.ItemId)) x.State = RowState.Delete;
    });
    this.IgnoredItems?.forEach((x) => {
      if (!this.model.IgnoredItems.some((r) => r.ItemId === x)) {
        var ignoredItem: PrintPolicyIgnoredItem = <PrintPolicyIgnoredItem>{};
        ignoredItem.ItemId = x;
        ignoredItem.PrintPolicyId = this.model.Id;
        ignoredItem.State = RowState.New;
        this.model.IgnoredItems.push(ignoredItem);
      }
    });
    this.setValue("IgnoredItems", this.model?.IgnoredItems);

    this.Items = this.formGroup.value.Items;
    this.model?.Items?.forEach((x) => {
      if (!this.Items.some((r) => r === x.ItemId)) x.State = RowState.Delete;
    });
    this.Items?.forEach((x) => {
      if (!this.model.Items.some((r) => r.ItemId === x)) {
        var item: PrintPolicyItem = <PrintPolicyItem>{};
        item.ItemId = x;
        item.PrintPolicyId = this.model.Id;
        item.State = RowState.New;
        this.model.Items.push(item);
      }
    });
    this.setValue("Items", this.model.Items);

    this.Printers = this.formGroup.value?.Printers;
    this.model?.Printers?.forEach((x) => {
      //if (!this.Printers.some(r => r === x.Name))
      x.State = RowState.Delete;
    });
    if (!this.islightVersion) {
      this.Printers?.forEach((x) => {
        var printPolicyPrinter: PrintPolicyPrinter = <PrintPolicyPrinter>{};
        printPolicyPrinter.Name = x;
        printPolicyPrinter.PrintPolicyId = this.model.Id;
        printPolicyPrinter.State = RowState.New;
        this.model.Printers.push(printPolicyPrinter);
      });
      this.setValue("Printers", this.model.Printers);
    } else {
      var printPolicyPrinter: PrintPolicyPrinter = <PrintPolicyPrinter>{};
      printPolicyPrinter.Name = this.Printers.toString();
      printPolicyPrinter.PrintPolicyId = this.model.Id;
      printPolicyPrinter.State = RowState.New;
      this.model.Printers.push(printPolicyPrinter);
      this.formGroup.controls["Printers"].setValue(this.model.Printers);
    }

    this.SaleMethodBranches = this.formGroup.value.SaleMethodBranches;
    this.model.SaleMethodBranches?.forEach((x) => {
      if (!this.SaleMethodBranches.some((r) => r === x.SaleMethodBranchId)) x.State = RowState.Delete;
    });
    this.SaleMethodBranches?.forEach((x) => {
      if (!this.model.SaleMethodBranches.some((r) => r.SaleMethodBranchId === x)) {
        var printPolicySaleMehod: PrintPolicySaleMethodBranch = <PrintPolicySaleMethodBranch>{};
        printPolicySaleMehod.SaleMethodBranchId = x;
        printPolicySaleMehod.PrintPolicyId = this.model.Id;
        printPolicySaleMehod.State = RowState.New;
        this.model.SaleMethodBranches.push(printPolicySaleMehod);
      }
    });
    this.setValue("SaleMethodBranches", this.model.SaleMethodBranches);

    this.Salons = this.formGroup.value.Salons;
    this.model?.Salons?.forEach((x) => {
      if (!this.Salons.some((r) => r === x.SalonId)) x.State = RowState.Delete;
    });
    this.Salons?.forEach((x) => {
      if (!this.model.Salons.some((r) => r.SalonId === x)) {
        var printPolicySalon: PrintPolicySalon = <PrintPolicySalon>{};
        printPolicySalon.SalonId = x;
        printPolicySalon.PrintPolicyId = this.model.Id;
        printPolicySalon.State = RowState.New;
        this.model.Salons.push(printPolicySalon);
      }
    });
    this.setValue("Salons", this.model.Salons);

    this.Dependents = this.formGroup.value?.Dependents;
    this.model?.Dependents?.forEach((x) => {
      if (!this.Dependents.some((r) => r === x.DependentPrintPolicyId)) x.State = RowState.Delete;
    });
    this.Dependents?.forEach((x) => {
      if (!this.model.Dependents.some((r) => r.DependentPrintPolicyId === x) && x !== this.model.Id) {
        var printPolicyDependency: PrintPolicyDependency = <PrintPolicyDependency>{};
        printPolicyDependency.DependentPrintPolicyId = x;
        printPolicyDependency.PrintPolicyId = this.model.Id;
        printPolicyDependency.State = RowState.New;
        this.model.Dependents.push(printPolicyDependency);
      }
    });
    this.setValue("Dependents", this.model.Dependents);
  }

  saveHasError() {
    this.model.Printers = [];
    this.formGroup.controls["Printers"].setValue(this.Printers);
  }

  setMaxCode() {}

  ReadPrintPolicies(id?: number) {
    this.httpCommonService
      .getItem("PrintPolicy/GetPrintPolicies", id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data: PrintPolicy[]) => {
        if (data) {
          this.PrintPolicies = data;
          this.PrintPolicyDependencies = this.PrintPolicies.filter(
            (x) => this.printTime.find((p) => p.Id == x.PrintTimeId).Code === PrintPolicyPrintTimeEnum.PreparationPrint
          );
        }
      });
  }

  ngAfterViewInit(): void {}

  setComputerName() {
    if (this.isNewRow) {
      const computerName: string = this.storage.getData(ClearableCache.ComputerName);
      this.model.ComputerName = computerName;
      this.setValue("ComputerName", this.model.ComputerName);
    } else this.setValue("ComputerName", this.model.ComputerName);
  }

  showLocalSetting() {
    this.orignalColumns.forEach((x) => {
      if (x.name === "LocalServiceIp" || x.name === "ComputerName" || x.name === "Connectionbtn")
        x.formVisible = this.formGroup.controls["HasLocalSetting"].value;
      if (this.formGroup.controls["HasLocalSetting"].value && x.name === "LocalServiceIp") x.required = true;
    });
    this.columns = this.orignalColumns.filter((f) => (!f.areaName || f.areaName === "default") && f.formVisible);
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    this.orignalColumns.forEach((col) => {
      if (col.name === "PrintTimeId") col.required = true;
    });
    if (!this.orignalColumns.some((s) => s.name === "Connectionbtn")) {
      const Connectionbtn = new form_control();
      Connectionbtn.name = "Connectionbtn";
      Connectionbtn.formVisible = !!this.model?.Id;
      Connectionbtn.label = this.translate("ClientApp.FrontOffice.PrintPolicy.CommunicationTest");
      Connectionbtn.userClass = "connection-test";
      Connectionbtn.columnNumber = 1;
      Connectionbtn.controlType = FormControlTypes.Button;
      this.orignalColumns.push(Connectionbtn);
      this.columns = this.orignalColumns;
    }
  }

  valueChangeByApiName(event: { KeyName: string; apiName: string; data: any }) {
    if (event?.KeyName === "PrintPolicyStencil" && event?.data) {
      this.setValue("Printers", event.data.Printers);
      this.setValue("PrintTemplateId", event.data.PrintTemplateId);
      this.setValue("Categories", event.data.Categories);
      this.setValue("Items", event.data.Items);
      this.setValue("IgnoredItems", event.data.IgnoredItems);
      this.setValue("SaleMethodBranches", event.data.SaleMethodBranches);
      this.setValue("Salons", event.data.Salons);
      this.setValue("Dependents", event.data.Dependents);
      this.setValue("PrintTimeId", event.data.PrintTimeId);
      this.valueChange();
    }
  }
  onDynamicFormChanges(controlName) {
    if (controlName === "Connectionbtn") {
      this.ConnectionTest();
    }
    if (controlName?.Category == "PrintTime") {
      this.onPrintTimeIdChanges(controlName?.Id);
    }
  }
  private ConnectionTest(): void {
    try {
      if (!this.formGroup.controls["LocalServiceIp"].value && this.formGroup.controls["HasLocalSetting"].value) {
        this.sts.showDialog(this.translate("ClientApp.FrontOffice.PrintPolicy.LocalServiceAddressMandatory"), "");
        return;
      }
      this.splashScreenService.startLoading();
      this.splashFormService.openDialog();
      if (!this.formGroup.controls["LocalServiceIp"].value) {
        this.splashScreenService.stopLoading();
        this.splashFormService.closeLoading();
        return;
      }
      const url = "http://" + this.formGroup.controls["LocalServiceIp"].value + "/TestConnection";
      this.httpCommonService
        .getCustom(url)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: any) => {
            if (data) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.PrintPolicy.ConnectionSuccessfullyEstablished"),
                this.translate("ClientApp.FrontOffice.PrintPolicy.Attention")
              );
              this.splashScreenService.stopLoading();
              this.splashFormService.closeLoading();
              const url = "http://" + this.formGroup.controls["LocalServiceIp"].value + "/GetPrinters";
              this.httpCommonService
                .getCustom(url)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (data: any) => {
                    if (data) {
                      this.PrinterList = data;
                      this.setValue("Printers", []);
                    }
                  },
                  (err) => {
                    console.log(err);
                  }
                );
            }
          },
          (err) => {
            this.sts.showDialog(
              `${this.translate("ClientApp.FrontOffice.PrintPolicy.CommunicationProblem")} ` + err,
              this.translate("ClientApp.FrontOffice.PrintPolicy.Attention")
            );
            this.splashScreenService.stopLoading();
            this.splashFormService.closeLoading();
            console.log(err);
          }
        );
    } catch (e) {
      this.sts.showDialog(
        `${this.translate("ClientApp.FrontOffice.PrintPolicy.CommunicationProblem")} ` + e,
        this.translate("ClientApp.FrontOffice.PrintPolicy.Attention")
      );
      console.log(e);
      this.splashScreenService.stopLoading();
      this.splashFormService.closeLoading();
    }
  }

  private onPrintTimeIdChanges(id: number): void {
    const findCode = this.printTime?.find((f) => f.Id == id)?.Code;
    this.customerPrint = findCode == PrintPolicyPrintTimeEnum.CustomerPrint;
    if (this.customerPrint) {
      this.clearDisableFields();
      this.orignalColumns.forEach((x) => {
        if (x.name === "IsOrderPrint") {
          x.formVisible = false;
        }
        if (x.name === "IsReceiptPrint") {
          x.formVisible = true;
        }
      });
    } else {
      this.orignalColumns.forEach((x) => {
        if (x.name === "IsOrderPrint") {
          x.formVisible = true;
        }
        if (x.name === "IsReceiptPrint") {
          x.formVisible = false;
        }
      });
    }
    if (this.currentrow && !this.model?.HasLocalSetting) {
      this.orignalColumns.forEach((x) => {
        if (x.name === "HasLocalSetting") {
          x.formVisible = false;
          x.required = false;
        }
      });
    } else {
      if (findCode == PrintPolicyPrintTimeEnum.CustomerPrint) {
        this.orignalColumns.forEach((x) => {
          if (x.name === "HasLocalSetting") {
            x.formVisible = true;
            x.required = true;
          }
          if (findCode === PrintPolicyPrintTimeEnum.CustomerPrint) if (x.name === "NonDefaultPrinting") x.formVisible = true;
          if (x.name === "LocalServiceIp" || x.name === "ComputerName" || x.name === "Connectionbtn") {
            x.formVisible = this.model?.HasLocalSetting;
            x.required = false;
          }
          if (x.name === "Title") x.isFloat = 1;
        });
      } else {
        this.orignalColumns.forEach((x) => {
          if (x.name === "HasLocalSetting" || x.name === "LocalServiceIp" || x.name === "ComputerName" || x.name === "Connectionbtn")
            x.formVisible = false;
          if (x.name === "Title") x.isFloat = 1;
          if (findCode === PrintPolicyPrintTimeEnum.PreparationPrint) if (x.name === "NonDefaultPrinting") x.formVisible = false;
        });
      }
    }
    this.columns = this.orignalColumns.filter((f) => (!f.areaName || f.areaName === "default") && f.formVisible);
  }

  valueChangeWithName($event) {
    if ($event.name == "HasLocalSetting") {
      this.showLocalSetting();
    }
  }

  clearDisableFields(): void {
    this.model.Dependents = null;
    this.model.IgnoredItems = null;
    this.model.Items = null;
    this.model.Categories = null;
    this.setValue("Dependents", null);
    this.setValue("IgnoredItems", null);
    this.setValue("Items", null);
    this.setValue("Categories", null);
  }
  afterupdate() {
    super.afterupdate();
    const computerName = this.storage.getData(ClearableCache.ComputerName);
    this.httpCommonService
      .get("PrintPolicy/GetAllPrintPolicy" + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(take(1))
      .subscribe((res: PrintPolicy[]) => {
        this.storage.savePermanentData(res, ClearableCache.PrintPolicy);
      });
  }
}
